import { useMediaQuery } from '@mui/material'
import React, { useState, createContext, useEffect } from 'react'

interface IMenu {
  children: React.ReactNode
}
export const MenuContext = createContext({
  toggle: true,
  pageTitle: '',
  /* eslint-disable @typescript-eslint/no-empty-function */
  updateValue: () => {},
  updateTitle: (title: string) => {},
  menusAvailables: [''],
  updateMenusAvailables: (menus?: string[]) => {},
})

export function MenuProvider({ children }: IMenu) {
  const [toggle, setToggle] = useState(true)
  const [pageTitle, setPageTitle] = useState('')
  const [menusAvailables, setMenusAvailables] = useState<string[]>([])

  const mobile = useMediaQuery('(max-width:991px)')

  const updateValue = () => {
    setToggle((t) => !t)
  }

  const updateTitle = (title: string) => {
    setPageTitle(title)
  }

  const updateMenusAvailables = (menus?: Array<string>) => setMenusAvailables(menus ?? [])

  useEffect(() => {
    if (mobile) {
      setToggle(true)
    }
  }, [mobile])

  return (
    <MenuContext.Provider
      value={{
        pageTitle,
        updateTitle,
        toggle,
        updateValue,
        menusAvailables,
        updateMenusAvailables
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}
